import { toast as sonnerToast } from 'sonner';

function toSafeString(value) {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  if (Array.isArray(value) && value[0] && typeof value[0] === 'object' && value[0].msg != null) return String(value[0].msg);
  if (typeof value === 'object' && value.msg != null) return String(value.msg);
  if (Array.isArray(value)) return value.map(toSafeString).join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}

export const toast = {
  ...sonnerToast,
  error: (message, opts) => sonnerToast.error(toSafeString(message), opts),
  success: (message, opts) => sonnerToast.success(toSafeString(message), opts),
  info: (message, opts) => sonnerToast.info(toSafeString(message), opts),
  warning: (message, opts) => sonnerToast.warning(toSafeString(message), opts),
  message: (message, opts) => sonnerToast.message(toSafeString(message), opts),
  promise: sonnerToast.promise,
  dismiss: sonnerToast.dismiss,
  loading: sonnerToast.loading,
};
